<button
    class="flex-align-center box-border flex w-full cursor-pointer gap-4 rounded-lg border border-solid border-[#dcdcdc] bg-white p-4 text-left dark:border-contrast-yellow dark:bg-contrast-black"
    [attr.aria-pressed]="isSelected"
    [attr.aria-label]="buildAriaLabel(card, isSelected)"
    [ngClass]="{
        'border-2 border-secondary dark:border-contrast-yellow': isSelected,
        '!p-[17px]': !isSelected
    }"
    (click)="omMethodSelected()"
    type="button">
    <div class="flex-align-center flex w-full gap-4" aria-hidden="true">
        <img
            class="h-7 dark:filter-yellow"
            *ngIf="card.imageUrl"
            src="{{ env.PAYMENT_PORTAL_URL + card.imageUrl }}"
            alt="" />
        <img class="h-7 dark:filter-yellow" *ngIf="!card.imageUrl" src="/assets/pm_unknown.svg" alt="" />
        <div>
            <p class="text-base font-bold">{{ card.type | translate }}</p>
            <p class="text-base">**** **** **** {{ card.lastFourDigits }}</p>
        </div>
    </div>
</button>
